import { useMocks } from '../../shared/env';
import type { ContractorBatchGateway } from './ContractorBatchGateway';
import { HttpContractorBatchGateway } from './HttpContractorBatchGateway';
import { MockContractorBatchGateway } from './MockContractorBatchGateway';

export const contractorBatchGateway: ContractorBatchGateway = useMocks ? new MockContractorBatchGateway() : new HttpContractorBatchGateway();
export type { ContractorBatchGateway } from './ContractorBatchGateway';
export * from './types';
